import React, { useEffect, useRef, useState } from 'react'
import { copyImageToClipboard } from 'copy-image-clipboard'
import classNames from 'classnames'

export default function useHoverContent ({
  url = '',
  copyText = 'Kopier',
  isCopiedText = 'Kopieret!',
  downloadText = 'Download',
  isDownloadedText = 'Downloaded!',
  playText = 'Afspil',
  pauseText = 'Pause'
}) {

  const [value, setValue] = useState(url)
  const [canCopy, setCanCopy] = useState(false)
  const [isCopied, setIsCopied] = useState(false)
  const [isDownloaded, setIsDownloaded] = useState(false)
  const [isMp4, setIsMp4] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)

  useEffect(() => {
    setValue(url)
    setCanCopy(!/svg|mp4/.test(url))
    setIsMp4(url.includes('mp4'))
  }, [url])

  const copyImage = () => {
    setIsCopied(true)
    copyImageToClipboard(value)
      .then(() => {
        setTimeout(() => setIsCopied(false), 2000)
      })
  }

  const renderCopyButton = () => {
    if (!canCopy) {
      return null
    }

    return (
      <div className={classNames('dm-button dm-button--copy', {
        'dm-button--show-checkmark': isCopied
      })} onClick={copyImage}>
        <span className="dm-button__checkmark"></span>
        {isCopied ? isCopiedText : copyText}
      </div>
    )
  }

  const renderMp4Button = () => {
    if (!isMp4) {
      return null
    }

    return (
      <div className={classNames('dm-button', {
        'dm-button--play': !isPlaying,
        'dm-button--pause': isPlaying
      })} onClick={() => setIsPlaying(!isPlaying)}>{isPlaying ? pauseText : playText}</div>
    )
  }

  const renderDownloadButton = () => {
    return (
      <a
        href={value}
        className={classNames('dm-button dm-button--download', {
          'dm-button--show-checkmark': isDownloaded
        })}
        download
        target={'_blank'}
        onClick={() => {
          setIsDownloaded(true)
          setTimeout(() => setIsDownloaded(false), 2000)
        }}
      >
        <span className="dm-button__checkmark"></span>
        {isDownloaded ? isDownloadedText : downloadText}
      </a>
    )
  }

  const hoverContent = () => {
    if (!value) {
      return null
    }

    return (
      <div className="dm-hover-content__content">
        {renderCopyButton()}
        {renderMp4Button()}
        {renderDownloadButton()}
      </div>
    )
  }

  const hoverClass = 'dm-hover-content'

  return {
    hoverClass,
    hoverContent,
    isPlaying
  }
}
